import { useTranslations } from 'next-intl';
import { VariantProps } from 'tailwind-variants';

import ArrowLeftIcon from '@/fo/icons/base/icons/arrow24.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { styles } from './UiKitButtonBack.styles';

type Variants = VariantProps<typeof styles>;

export interface UiKitButtonBackProps {
  className?: string;
  children?: React.ReactNode;
  visibility?: Variants['visibility'];
  onClick?: () => void;
}

export function UiKitButtonBack({
  className,
  children,
  onClick,
  visibility
}: UiKitButtonBackProps) {
  const slots = styles({ visibility });
  const t = useTranslations();

  return (
    <UiKitButtonBase
      color="ghost"
      onClick={onClick}
      className={slots.button({ className })}
    >
      <ArrowLeftIcon className={slots.icon()} />
      <span className={slots.label()}>{children || t('back')}</span>
    </UiKitButtonBase>
  );
}
